export default __webpack_public_path__ + "static/d09-a5c37836c6b3eaa4564285af5d0c65d8.png";